import React, {useEffect, useRef, useState} from 'react';
import {View, ScrollView, StyleSheet, useWindowDimensions} from 'react-native';
import {GHAWelcomePageFetchHTML} from '../../Redux/Actions/ghaAction';
import RenderHTML from 'react-native-render-html';
import WebView from 'react-native-webview';
import HeaderWithBack from '../../components/Header/headerWithBack';

const GHALoyaltyProgram = ({navigation}) => {
  const {width, height} = useWindowDimensions();
  const webViewRef = useRef(null);

  useEffect(() => {
    const fetchHtmlContent = async () => {
      try {
         await GHAWelcomePageFetchHTML();
      } catch (error) {
        console.error('Error fetching HTML content:', error);
      }
    };

    fetchHtmlContent();
  }, []);

  const tagsStyles = {
    body: {
      fontFamily: 'Arial',
      color: '#333',
    },
    h3: {
      color: 'black',
      textAlign: 'center',
      fontSize: 20,
      marginTop: 50,
      // marginHorizontal: 16,
      // backgroundColor: 'pink'
    },
    p: {
      fontSize: 16,
      color: 'black',
    },
  };

  const classesStyles = {
    'widget-header-title': {
      fontSize: 22,
      fontWeight: 'bold',
      color: 'black',
      textAlign: 'center',
      marginVertical: 10,
      marginHorizontal: 16,
    },
    'form-controls': {
      backgroundColor: 'black',
    },
    primary: {
      backgroundColor: '#007bff',
      color: '#fff',
      paddingVertical: 10,
      paddingHorizontal: 20,
      textAlign: 'center',
      borderRadius: 5,
    },
    secondary: {
      backgroundColor: '#ccc',
      color: '#333',
      paddingVertical: 10,
      paddingHorizontal: 20,
      textAlign: 'center',
      borderRadius: 5,
    },
    'step-row': {
      alignItems: 'center',
      justifyContent: 'center',
    },
    'step-num': {
      backgroundColor: '#b5874a',
      textAlign: 'center',
      alignItems: 'center',
      borderRadius: 50,
      width: 80,
      height: 80,
      marginVertical: 20,
    },
    'step-heading': {
      fontSize: 20,
    },
  };
  const url = 'https://app.viceroy.com:8443/Connector/rest/assets?type=rewardsProgramHtml&languageCode=en'

  return (
    // <View style={styles.ghaContainer}>
    //   <HeaderWithBack navigation = {navigation}/>

    //   <ScrollView
    //     contentContainerStyle={[styles.container, {minHeight: height}]}
    //     showsVerticalScrollIndicator={false}>
    //     <RenderHTML
    //       contentWidth={width}
    //       source={{html: htmlContent}}
    //       tagsStyles={tagsStyles}
    //       classesStyles={classesStyles}
    //     />
    //   </ScrollView>
    // </View>
    <>
      <HeaderWithBack navigation = {navigation}/>
      <WebView
        ref={webViewRef}
        style={styles.webview}
        originWhitelist={['*']}
        source={{uri: url}}
        // onMessage={onMessage}
        showsVerticalScrollIndicator={false}
        startInLoadingState={true}
        // javaScriptEnabled={true}
        webviewDebuggingEnabled={true}
        pullToRefreshEnabled={true}
        cacheEnabled={true}
        onNavigationStateChange={(state) => {
          console.log('Navigation state change:', state);
        }}
      />
      </>
  );
};

const styles = StyleSheet.create({
  // ghaContainer: {
  //   flex: 1,
  //   backgroundColor: '#fff',
  // },
  // container: {
  //   padding: 20,
  // },
  container: {
    flex: 1,
  },
  webview: {
    flex: 1,
  },
});

export default GHALoyaltyProgram;
